// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1Lwsl","alertIcon":"ConfirmModal_alertIcon__2cWg2"};